module.exports = __webpack_public_path__ + "static/img/empty.c1f6e46.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/empty.png
// module id = fakP
// module chunks = 0